import type {ReactElement} from 'react';
import React from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {v4 as uuidv4} from 'uuid';
import styles from './contextual-menu-skeleton.module.scss';

const NUM_BASE_SKELETONS = 3;

export function ContextualMenuSkeleton(): ReactElement<any> {
  const getSkeletonSubContainer = (): ReactElement<any> => {
    return (
      <div key={uuidv4()} className={`flex-v-row ${styles.skeletonSubContainer}`}>
        <div className="flex-row-justify-between">
          <SkeletonBrick className={styles.leftSkeleton} />
          <SkeletonBrick className={styles.rightSkeleton} />
        </div>
        <SkeletonBrick className="spacing-m-t-3" height={51} />
      </div>
    );
  };

  const getBaseSkeleton = (): Array<ReactElement<any>> => {
    const baseSkeleton: Array<ReactElement<any>> = [];
    for (let index = 0; index < NUM_BASE_SKELETONS; index += 1) {
      baseSkeleton.push(getSkeletonSubContainer());
    }

    return baseSkeleton;
  };

  return (
    <div className={styles.container}>
      <div className={`${styles.headerContainer} flex-center`}>
        <SkeletonBrick className={styles.headerSkeleton} height={16} />
      </div>
      <div className={styles.mainSection}>{getBaseSkeleton()}</div>
    </div>
  );
}
